import { Text } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import { Ciap, Cid10, Cid11 } from 'graphql/types.generated'
import { Fragment } from 'react'

interface HistoricoAvaliacaoProblemasCondicoesCiapCidTableContentProps {
  ciap?: Pick<Ciap, 'descricao' | 'codigo'> | null
  cid10?: Pick<Cid10, 'nome' | 'codigo'> | null
  cid11?: Pick<Cid11, 'nome' | 'codigo'> | null
}

export function HistoricoAvaliacaoProblemasCondicoesCiapCidTableContent(
  props: Readonly<HistoricoAvaliacaoProblemasCondicoesCiapCidTableContentProps>
) {
  const { ciap, cid10, cid11 } = props
  const { PILOTO_CID11_ENABLED } = useFlags()

  const hasCiap = !!ciap
  const hasCid10 = !!cid10
  const hasCid11 = !!cid11
  const mustShowCid11 = PILOTO_CID11_ENABLED && hasCid11

  return (
    <Fragment>
      {hasCiap && (
        <Fragment>
          <Text fontWeight='bold'>{`${ciap.descricao} - ${ciap.codigo} `}</Text>
          <Text>(CIAP 2)</Text>
        </Fragment>
      )}

      {hasCiap && hasCid10 && <Text> | </Text>}

      {hasCid10 && (
        <Fragment>
          <Text fontWeight='bold'>{`${cid10.nome} - ${cid10.codigo} `}</Text>
          <Text>(CID 10)</Text>
        </Fragment>
      )}

      {mustShowCid11 && (hasCiap || hasCid10) && <Text> | </Text>}

      {mustShowCid11 && (
        <Fragment>
          <Text fontWeight='bold'>{`${cid11.nome.toUpperCase()} - ${cid11.codigo} `}</Text>
          <Text>(CID 11)</Text>
        </Fragment>
      )}
    </Fragment>
  )
}
